import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { OrgActivity } from './useGetOrgActivitiesQuery'

export interface ExternalActivitySearchParams {
    statuses?: string[]
    studyTitle?: string
    type?: string
    types?: string[]
    therapeuticArea?: string
    therapeuticAreas?: string[]
    genericName?: string
    genericNames?: string[]
    sources?: string[]
    compoundName?: string
    compoundNames?: string[]
    indications?: string[]
    studyId?: string
    // Study numbers the connector excludes before paginating (powers "Hide already imported").
    excludeStudyNumbers?: string[]
    limit?: number
    offset?: number
}

export interface ExternalActivitySearchResponse {
    results: OrgActivity[]
    total: number
    limit: number
    offset: number
}

const FIVE_MINUTES = 5 * 60 * 1000

export const useSearchExternalActivitiesQuery = (params: ExternalActivitySearchParams, enabled: boolean) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    return useQuery<ExternalActivitySearchResponse>(
        ['externalActivitiesSearch', params],
        async () => {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const res = await callAPI(
                endpoints.searchExternalActivities.url,
                endpoints.searchExternalActivities.method,
                token,
                params
            )
            return res as ExternalActivitySearchResponse
        },
        {
            enabled: enabled && !!getTokenSilently && !!isAuthenticated && !isLoading,
            keepPreviousData: true,
            staleTime: FIVE_MINUTES,
            refetchOnWindowFocus: false,
            retry: false,
        }
    )
}
